import { ref } from "vue"

import { PensionRecommendationsService } from "../../../../packages/pension-portfolio/composables/services/pension-recommendations.service"

const selectedPensionRecommendationService = ref<typeof PensionRecommendationsService>(
  PensionRecommendationsService
)

export function usePensionRecommendationService() {
  function setPensionRecommendationService(service: typeof PensionRecommendationsService) {
    selectedPensionRecommendationService.value = service
  }

  return {
    pensionRecommendationService: selectedPensionRecommendationService,
    setPensionRecommendationService,
  }
}
